export const VideoOverlayTypes = {
  NONE: 'NONE',
  CTA: 'CTA',
  FORM: 'FORM'
};
export const VideoOverlayPositions = {
  BEFORE: 'PRE',
  AFTER: 'POST'
};
export const ConversionAssetTypes = {
  FORM: 'FORM',
  CTA: 'CTA'
};
export const ConversionAssetPosition = {
  PRE: 'PRE',
  POST: 'POST',
  CUSTOM: 'CUSTOM'
};
export const VideoSizes = {
  CUSTOM: 'customWidth',
  FULL: 'fullWidth'
};
export const VideoParamTypes = {
  LOOP: 'loop',
  MUTED: 'muted',
  AUTOPLAY: 'autoplay',
  HIDE_CONTROLS: 'hidden_controls'
};
export const PlayerMessageTypes = {
  SET_CURRENT_TIME: 'SET_CURRENT_TIME',
  UPDATE_DISPLAY_OPTIONS: 'UPDATE_DISPLAY_OPTIONS'
};